/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { ManagedByBackupServer } from './components';

export const BackupJobsManagedByBackupServerPage: React.FC<{}> = () => (
    <TabBarBodyLayout>
        <ManagedByBackupServer />
    </TabBarBodyLayout>
);
